export const MAX_CHARS_FOR_FIELD = 50;

// Just digits
export const DIGITS_ONLY = /^[0-9-]*$/;

// Digits and hyphens
export const DIGITS_AND_HYPHENS = /^[0-9-]*$/;

// Letters, space, and hyphen
export const LETTERS_AND_SPACES = /^[a-zA-Z -]*$/;
export const LETTERS_AND_SPACES_MESSAGE = 'Only letters and spaces allowed';

// Using Unicode property matching
export const LETTERS_AND_SPACES_UNICODE = /^[\p{L} -]*$/gu;
// Allow for dashes and other classes of characters to?

// Regular Expressions for form validations
export const NO_LEADING_WHITE_SPACE = /^[\S].*$/;
export const NO_TRAILING_WHITE_SPACE = /^.*[\S]$/;
export const TRIM_WHITE_SPACE_MESSAGE =
  'No leading or trailing white space allowed.';

export const PHONE_NUMBER = /^\(\d{3}\)[\s]?\d{3}-\d{4}$/;


// Form items
export const W9_BLANK_FORM = "https://my.btisinc.com/portals/0/agent-registration/w_9_doc.pdf";